import { Box, Button, Paper, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { ReactNode } from "react";

interface Props {
  icon: ReactNode;
  label: string;
  value: string;
  onEdit?: () => void;
  editLabel?: string;
  /** Mantiene el botón visible pero sin acción (ej. el dato ya fue verificado y no se puede cambiar). */
  editDisabled?: boolean;
}

/**
 * Replica `.ld-rfc-banner`: banner de un dato prellenado (teléfono, RFC, etc.)
 * con ícono, label/valor y botón opcional de editar. Reusable en cualquier
 * step que muestre un dato ya capturado antes (ValTelefono, ConexionSAT).
 */
export const InfoBanner = ({ icon, label, value, onEdit, editLabel = "Cambiar", editDisabled = false }: Props) => (
  <Paper
    variant="lendia_paper"
    sx={{ p: "18px 22px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "9px",
          bgcolor: "primary.dark",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: "text.secondary",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            mb: "2px",
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Outfit",
            fontSize: 22,
            fontWeight: 600,
            letterSpacing: "0.04em",
            color: "primary.dark",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>

    {onEdit && (
      <Button
        variant="outlined"
        onClick={onEdit}
        disabled={editDisabled}
        startIcon={<Edit sx={{ fontSize: 14 }} />}
        sx={{
          height: 34,
          // px: "14px",
          bgcolor: "background.paper",
          borderColor: "#D6DBE3",
          borderRadius: "8px",
          color: "text.secondary",
          fontSize: 13,
          fontWeight: 500,
          // fontFamily: "Outfit",
          // textTransform: "none",
          "&:hover": { borderColor: "primary.main", color: "primary.main", bgcolor: "background.paper" },
          // El `color`/`borderColor` de arriba gana sobre el default de MUI, así que el estado
          // deshabilitado se declara explícitamente con el mismo gris de los inputs `lendia_input`.
          "&.Mui-disabled": { borderColor: "#E4E7EC", color: "text.disabled", bgcolor: "#F2F5F9" },
        }}
      >
        {editLabel}
      </Button>
    )}
  </Paper>
);
